// extracted by mini-css-extract-plugin
export default {"overlay":"FloatingLoader_overlay__aajef"};